import React from 'react';
import { PricingRegion, REGION_LABELS } from '../../types/subscription';

interface BillingControlsProps {
  billingCycle: 'monthly' | 'annual';
  setBillingCycle: (cycle: 'monthly' | 'annual') => void;
  region: PricingRegion;
  setRegion: (region: PricingRegion) => void;
}

const BillingControls: React.FC<BillingControlsProps> = ({
  billingCycle,
  setBillingCycle,
  region,
  setRegion,
}) => {
  return (
    <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6">
      {/* Billing Cycle Toggle */}
      <div className="flex items-center gap-4 bg-gray-100 rounded-full p-1">
        <button
          onClick={() => setBillingCycle('monthly')}
          className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
            billingCycle === 'monthly'
              ? 'bg-white text-gray-900 shadow'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Monthly
        </button>
        <button
          onClick={() => setBillingCycle('annual')}
          className={`px-6 py-2 rounded-full text-sm font-medium transition-colors ${
            billingCycle === 'annual'
              ? 'bg-white text-gray-900 shadow'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Annual
          <span className="ml-2 text-xs text-green-600 font-semibold">Save 40%</span>
        </button>
      </div>

      {/* Region Selector */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">Region:</span>
        <select
          value={region}
          onChange={(e) => setRegion(e.target.value as PricingRegion)}
          className="border border-gray-200 bg-white text-gray-900 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {Object.entries(REGION_LABELS).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default BillingControls;
